import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-t border-gray-200 bg-white" }
const _hoisted_2 = { class: "mx-auto max-w-4xl px-6 py-8 text-sm text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " © " + _toDisplayString(new Date().getFullYear()) + " Nevcap. All rights reserved. ", 1)
  ]))
}